jQuery(document).ready(function($) {

  $('.js-agend-event-menu').on('click', function () {
      $('.agend-event__menu').slideToggle('400', function() {
        setMainPlusOrMinus();
    });
  });

  function isMobile() {
    return $('.js-agend-event-menu').is(':visible');
  }

  function setMainPlusOrMinus() {
    var subnavBtn$ = $('.js-agend-event-menu');
    if ($('.agend-event__menu').is(':visible')) {
      subnavBtn$.addClass('open');
    } else {
      subnavBtn$.removeClass('open');
    }
  }

  $('.agend-event__menu .menu-item-has-children').on('click', function (e) {
      e.preventDefault();
      $(this).find('a').toggleClass('open');
  });

  $('.agend-event__menu .sub-menu a').on('click', function (e) {
    e.stopImmediatePropagation();
  });

  $('.agend-event__menu .menu-item-has-children.current-menu-ancestor a').addClass('open');
  $('.agend-event__menu .menu-item-has-children.current-menu-item a').addClass('open');

  // Handle window resizes
  $(window).on('resize', function () {
    if (!isMobile()) {
      $('.agend-event__menu').show();
    }
    setMainPlusOrMinus();
  });
});
